<template>
  <br />
  <br />
  <br />
  <section class="content-page">
    <div class="container-fluid">
      <section class="hero">
        <div class="container">
          <div class="roww">
            <h1 class="text-uppercase">Telephony</h1>
            <span class="text">
              <p>
                Datatex has been involved in the telephony industry for over 25
                years. It’s previously established advanced skills in technical
                development and a desire to find an exciting market to utilize
                its technical skills and presenting high quality applications
                brought forward the company as it is seen today. With the
                ever-growing importance of communication and specifically
                telecommunications, Datatex strives to stay ahead of the curve
                with its telephony software solutions. The decision to become a
                major role player in the telephony industry has proven to be
                exciting and profitable beyond expectations.
              </p>
            </span>
            <h1 class="text-uppercase">Mission</h1>
            <span class="text">
              <p>
                To be South Africa’s most client focused company and to provide
                products where companies can come to find and discover their
                business needs.
              </p>
            </span>
            <h1 class="text-uppercase">Exports</h1>
            <span class="text">
              <p>
                Our products are currently sold in various African countries
                such as Namibia, Botswana, Swaziland and Zimbabwe. We have
                strong representation in Botswana and Namibia with active
                dealers promoting and selling our products.
              </p>
            </span>
          </div>
        </div>
      </section>

      <section class="mission">
        <div class="container">
          <div class="row">
            <h2 class="text">Why Datatex</h2>
            <span class="text">
              <br />
              <p>
                Datatex Dynamics has been providing software solutions since
                1994, and with more than 25 years’ experience in the market, our
                business has grown to provide telephony software solutions to
                thousands of companies.
              </p>
              <p>
                Datatex distinguishes itself from its competitors by providing
                the most quality enhanced products on the telecommunications
                market. It is also a brand that is focused on constant
                development and innovation.
              </p>
              <p>
                The customer’s feedback is important to Datatex who is always
                developing new and better functionality to keep its clients
                satisfied. Datatex has always been a leader and innovator in
                many aspects of its design and development process and the final
                systems it produces. Technical teams and resellers are
                established in most parts of Southern Africa for ease of client
                service.
              </p>
            </span>
          </div>
        </div>
      </section>
    </div>
  </section>
</template>

<script>

</script>

<style scoped>
.roww {
  text-align: justify;
  text-justify: inter-word;
  padding-top: 70px;
  padding-bottom: 70px;
}
.mission {
  text-align: justify;
  text-justify: inter-word;
}

.container-fluid {
  padding: 0;
}

.container {
  width: 80%;
}

.content-page h1,
.content-page h3,
.content-page h4 {
  margin: 0;
  padding: 10px 0 10px 0;
}
.content-page h2 {
  padding: 4px 12px;
}

.content-page .row {
  padding: 30px 0 40px 0;
}

.content-page h2 {
  color: white;
  font-size: 23px;
  background-color: #2c4a66;
}
.content-page p {
  color: #000;
  font-size: 21px;
}

.content-page a {
  color: #000;
  font-weight: 600;
}

.content-page .hero {
  position: relative;
  height: auto;
  background-image: url("https://i.ibb.co/1fCPXH2v/man-8676539-1280.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  display: flex;
  justify-content: center;
  flex-direction: column;
  color: white;
  z-index: 1;
}

.content-page .hero::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    to right,
    rgba(8, 1, 68, 0.8),
    rgba(0, 0, 0, 0.8)
  );
  z-index: 0;
}

.content-page .hero > * {
  position: relative;
  z-index: 1; /* Keeps the text above the overlay */
}

.content-page .hero h1 {
  color: #fff;
  font-size: 23px;
}
.content-page .hero p {
  color: #fff;
  font-size: 21px;
}

@media (min-width: 1400px) {
  .container,
  .container-lg,
  .container-md,
  .container-sm,
  .container-xl,
  .container-xxl {
    max-width: 80%;
  }
}
</style>
